<template>
   <div class="outerCtn" ref="outerCtn">
    <div class="mytabs" :style="{top : hideHeight ? '0' : '54px'}">
        <div v-for="(item,index) in tabs" :key="item.key" :style="{color:item.isActive ? '#3170FF':'#FFF' , borderBottom:item.isActive ? '2px solid #3170FF' : 'none'}" @click="changeActive(index)">
            {{ item.name }}
        </div>
    </div>
    <div class="article" v-if="activeIndex == 0">
        <p>用户价值</p>
        <div class="imgCtn">
            <img src="@/assets/home_line.png" alt="" srcset="">
        </div>
        <div class="detail">
            <div v-for="item in userVal" :key="item.id">
                <div class="detail-title">{{ item.title }}</div>
                <div class="detail-content">{{ item.content }}</div>
            </div>
        </div>
    </div>
    <div class="article" v-if="activeIndex == 1">
        <p>应用场景</p>
        <div class="imgCtn">
            <img src="@/assets/home_line.png" alt="" srcset="">
        </div>
        <div class="detail">
           <img src="@/assets/M.png" alt="" srcset="" style="height:235px">
            <p class="describeTion">针对不同建筑楼宇类型，实现智能化系统大集成、能耗量化分析、冷热源控制、智能运维系统，在设备台账、设备巡检、智能工单、维保计划、绩效管理、空气品质决策控制等方面业务的落地。</p>
        </div>
    </div>
    <div class="article" v-if="activeIndex == 2">
        <p>功能亮点</p>
        <div class="imgCtn">
            <img src="@/assets/home_line.png" alt="" srcset="">
        </div>
        <div class="detail">
            <div class="lightPoint">硬件功能亮点</div>
            <div v-for="(item,index) in hardware" :key="index">
                <div class="hardWare">
                    <img :src="item.assets" alt="" style="height:20px">
                    {{item.title}}
                </div>
                <div class="hardWare-text">
                    {{item.content}}
                </div>
            </div>
        </div>
        <div class="detail">
            <div  class="lightPoint">软件功能亮点</div>
            <div v-for="(item,index) in software" :key="index">
                <div class="hardWare">
                    <img :src="item.assets" alt="" style="height:20px">
                    {{item.title}}
                </div>
                <div class="hardWare-text">
                    {{item.content}}
                </div>
            </div>
        </div>
    </div>
    <div class="article" v-if="activeIndex == 3">
        <p>落地案例</p>
        <div class="imgCtn">
            <img src="@/assets/home_line.png" alt="" srcset="">
        </div>
        <div class="detail">
            <el-carousel height="325px"  arrow="always">
                <el-carousel-item v-for="(item,index) in carouselData" :key="index" class="adjust">
                    <p style="font-size:18px;margin-bottom:16px">{{item.title}}</p>
                    <img :src="item.assets" alt="" srcset="" style="height:100px" @click="tolink(index)">
                    <p style="font-size:12px;letter-spacing:1.5px;line-height:18px;text-indent: 1cm;text-align:left;margin-top:20px;">{{item.content}}</p>
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
   </div>
</template>

<script>
import img1 from '../../../assets/userVal/1.png'
import img2 from '../../../assets/userVal/2.png'
import img3 from '../../../assets/userVal/3.png'
import img4 from '../../../assets/userVal/4.png'
import img5 from '../../../assets/userVal/5.png'
import img6 from '../../../assets/userVal/6.png'
import img11 from '../../../assets/userVal/11.png'
import img22 from '../../../assets/userVal/22.png'
import img33 from '../../../assets/userVal/33.png'
import img44 from '../../../assets/userVal/44.png'
import img55 from '../../../assets/userVal/55.png'
import img66 from '../../../assets/userVal/66.png'
import img77 from '../../../assets/userVal/77.png'
import img88 from '../../../assets/userVal/88.png'
import cqjy from '../../../assets/userVal/cqjy.png'
import ifc from '../../../assets/userVal/ifc.png'
import xc from '../../../assets/userVal/xc.png'
import ysgj from '../../../assets/userVal/ysgj.png'
import ftxl from '../../../assets/userVal/ftxl.png'
import zd from '../../../assets/userVal/zd.png'
import yh from '../../../assets/userVal/yh.png'


export default {
    data() {
        return {
            tabs:[
                {name:'用户价值',key:1,isActive:true},{name:'应用场景',key:2,isActive:false},{name:'功能亮点',key:3,isActive:false},{name:'落地案例',key:4,isActive:false}
            ],
            activeIndex:0,
            userVal:[
                {title:'数字化能耗管理',content:'预付费收费、节能监管、能耗分析、电量、水表集采系统'},
                {title:'智能化的多级远程管控',content:'树状管理结构，设备运行监控、异常报警，支持角色分配、客服收费、工程管理'},
                {title:'综合性的财务支持',content:'电费缴纳限制，支持其它类型收费，自动数据报表'},
                {title:'零试错成本',content:'免费提供硬件、软件，先施工、先落地、后收费'},
            ],
            hardware:[
                {title:'功能板块',assets:img1,content:'智能收费系统、能耗监测系统、节能管理系统'},
                {title:'设置功能',assets:img2,content:'定时开关设置，峰平谷电价、 阶梯电价、拉合闸控制'},
                {title:'主动保护功能',assets:img3,content:'额定电流过载保护、缺相指示、压线松动状态报警，窃电报警'},
                {title:'数据监测项',assets:img4,content:'电流、电压、功率因数、有功电量、无功电量、组合有功电量、 组合无功电量'},
                {title:'计量方式',assets:img5,content:'正向、反向、有功、无功计量'},
                {title:'收费方式',assets:img6,content:'预付费、后付费、可灵活设置收费模式'}
            ],
            software:[
                {title:'智能化管理',assets:img11,content:'智能监控、智能分析、智能告警'},
                {title:'一站式综合收费',assets:img22,content:'手机缴费，各类费用账单自动发送，无需人工送单；结合停电或限制缴电费，实现费用100%收缴率；各类财务报表自动生成且进行分析，支持Excel导出，实现财务溯源'},
                {title:'防窃电管理',assets:img33,content:'反接同步计量、预警表外窃电、人工智能推送'},
                {title:'智能公摊',assets:img44,content:'多种模型自动计算公摊、自动发送账单收取公摊、方案通过物价部门验收'},
                {title:'线损分析',assets:img55,content:'通过分区、分片、分电压等进行线损统计，精细化管理；做好日\月\年度线损率数据可视图，掌握系统有功、无功潮流、电压等情况为制定节能方案提供依据'},
                {title:'公区对比',assets:img66,content:'通过对公区重点设备进行实时监控、能耗时段分析等，管理者能够准确掌握能源成本比重和发展趋势，增加楼层、公区之间的环比'},
                {title:'能耗数字化展示',assets:img77,content:'平台会将能耗数据进行统计分析，转换为可视化图表的形式，可以直观的看出每天\月\年的用电量、用电异常的时间段、正常用电、同比上月/年的变化、区域耗电量对比的规律等数据'},
                {title:'智慧节能方案推送',assets:img88,content:'系统依据历史使用数据，自动制订有效可行的节能策略，降低运营成本，实现节能增效。如公区中央空调、电梯、公共照明、弱电系统等'}
            ],
            carouselData:[
                {title:'重庆·金源时代购物中心',link:"https://mp.weixin.qq.com/s/tvHmaBGxhL-IxdJn4_UBzw", assets:cqjy,content:'项目位于重庆市江北区观音桥正前方，重庆最具发展潜力的北滨路核心区金源大道路口，是世纪金源集团继成功打造观音桥地标项目金源大饭店后，在重庆的又一地标性建筑，总商业面积35万平方米。包含日用百货、大型超市、专业市场、家居卖场等多种业态。'},
                {title:'济南IFC中央公馆',link:"https://mp.weixin.qq.com/s/T-dGlrs_G0y04sW5E-wgeA", assets:ifc,content:'济南IFC中央公馆位于济南市历下化纤厂路，总建筑面积16.4万㎡，共计房屋1444户。IFC中央公馆身处济南CBD，占整个CBD面积的1/4。业态分布主要为420米山东第一高楼办公、酒店、高端主题商业、新天地商业街、办公及高端住宅。项目开发分为五期。'},
                {title:'西昌唐园',link:"https://mp.weixin.qq.com/s/c2BEpgaypMFExaH8lqCHmA", assets:xc,content:'唐园坐落于四川省西昌市建昌东路，项目计划总投资7.78亿元，规划用地总面积约11万平方米，建筑总面积7万多平方米。该项目作为西昌市创建“省级公园城市”的重点文旅项目，是西昌深入挖掘历史文化、展示本地地域特色、拓展城市空间的重点体现。致力于打造成唐“潮”艺术生活街区，集文化旅游、商业为一体的综合性城市公园。'},
                {title:'广州合景誉山国际',link:"https://mp.weixin.qq.com/s/aK6TEqwqus8B9y1-xVF1sA", assets:ysgj,content:'合景誉山国际项目位于广州市增城区，总投资额约110亿元，建筑面积254万平方米，是集酒店、会展、购物城、写字楼、住宅于一身的3000亩大型综合体。合景誉山国际分五期开发，首期包括酒店、会展、购物、商业街、写字楼和住宅，建筑面积超过30万平方米。二期为纯别墅区，分南北两区，共有独栋、双拼等别墅。三期为洋房区。除此以外，小区周边规划有医院、国际学校、运动场馆、文化活动中心幼儿园、小学、中学等。'},
                {title:'西安富平新里城',link:"https://mp.weixin.qq.com/s/MB0T00p7xizsLop5I_FnxA", assets:ftxl,content:'西安富平绿地新里城，位于西安市荆山大道与怀德大街交汇处。项目隶属于绿地集团新里系的高端产品系，它缘起新式里弄，中西合璧，充分结合了“传统，品质，人文，智慧”四大特质，打造高端人文社区，主要针对城市菁英。项目总占地228亩，总规划33万方、42栋楼，容积率低至1.8，分两个地块开发。产品含住宅、商业5300㎡及教育配套设施。'},
                {title:'中电建云立方',link:"https://mp.weixin.qq.com/s/QfYSSSAksVhnLmOBibBHeQ", assets:zd,content:'云立方项目地处成都市龙泉驿区龙城大道816号，项目总占地128亩，项目住宅部分建筑面积38.2万平米，并配套4.1万平米建面商业，项目内还规划有幼儿园。'},
                {title:'广州永荟广场',link:"https://mp.weixin.qq.com/s/2DkY2nsVtulyPSBoiqV9LA", assets:yh,content:'永荟广场项目位于广州东TOD国际交通枢纽附近（香山大道与创新大道交汇处），占地面积约21万㎡，总建面约75万㎡大型商业综合体。项目落成后将成为新塘开发区的商业核心圈，项目本身自带建面约23万㎡永旺梦乐城华南旗舰店，加上项目旁的新塘万达广场等商业，将为区域带来百万消费人群。'},
            ],
            hideHeight:false
        }
    },
    methods:{
        changeActive(index){
            for (let i = 0; i < this.tabs.length; i++) {
                if(index == i){
                    this.tabs[i].isActive = true
                }else{
                    this.tabs[i].isActive = false
                }
            }
            this.activeIndex = index
        },
        tolink(i){
            let link = this.carouselData[i].link
            window.open(link, '_blank')
        },
    },
    mounted() {
        window.onscroll=()=>{
            if(document.documentElement.scrollTop == 0 || document.body.scrollTop == 0 ){
                this.hideHeight = false
            }
            if(document.documentElement.scrollTop > 50 || document.body.scrollTop > 50 ){
                this.hideHeight = true
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.mytabs{
    display: flex;
    justify-content: space-between;
    padding: 0 14px;
    font-size: 14px;
    font-family: SourceHanSansCN-Regular;
    padding-top:19px;
    border-radius: 4px;
    width: 100%;
    height: 54px;
    position: fixed;
    left: 0;
    background-color: #24282E;
    transition:all 0.1s ease-out 0s;;
}
.outerCtn{
    background-color: #24282E;
    position: relative;
    color: white;
    min-height: 100vh;
    .article{
        margin: 0 20px 0 20px;
        padding-top: 80px;
        padding-bottom: 10px;
        text-align: left;
        p{
            font-size: 22px;
            font-family: Alibaba PuHuiTi;
            font-weight: 500;
            padding-bottom: 10px;
            text-align: center;
        }
        .imgCtn{
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            width:84px;
            height: 3px;
          }
        }
    }
    .detail{
        background-color: #2d2f33;
        margin-top: 20px;
        border-radius: 4px;
        overflow: hidden;
        padding: 26px 20px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        .lightPoint{
            text-align: center;
            font-size: 19px;
            font-family: Alibaba PuHuiTi;
            font-weight: 500;
            height: 36px;
        }
        .detail-title{
            font-size: 14px;
            font-family: Alibaba PuHuiTi;
            font-weight: 500;
            color: #3170FF;
            border-left: 3px solid #3170FF;
            padding-left: 13px;
        }
        .detail-content{
            margin: 15px 0;
            font-size: 12px;
            letter-spacing:1.5px;
            line-height:16px
        }
        .describeTion{
            font-size: 12px;
            letter-spacing:2px;
            line-height:16px;
            text-indent: 0.5cm;
            text-align: left;
            margin-top: 10px;
        }
    }
    .detail .hardWare{
        text-align: left;
        display: flex;
        font-size: 14px !important;
        font-weight: 500;
        color: #3170FF;
        align-items: center;
        margin-top: 6px;
        img{
            padding-right: 8px;
        }
    }
    .hardWare-text{
        font-size: 12px;
        letter-spacing:2px;
        line-height:20px;
        margin-left: 32px;
    }
}
.adjust{
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>
<style>
   .article .detail .el-carousel__indicator--horizontal{
        display: none;
    }
    .article .detail .el-carousel__arrow{
        top:30%;
    }
</style>



// WEBPACK FOOTER //
// src/components/page/phone/phoneUserVal.vue